import { render, staticRenderFns } from "./PricingDisplay.vue?vue&type=template&id=63f9c9da&scoped=true&"
import script from "./PricingDisplay.vue?vue&type=script&lang=js&"
export * from "./PricingDisplay.vue?vue&type=script&lang=js&"
import style0 from "./PricingDisplay.vue?vue&type=style&index=0&id=63f9c9da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9c9da",
  null
  
)

export default component.exports